const code = {
  'True': 1,
  'False': 0,
};

const sortedCodes = Object.keys(code)
  .sort()
  .reduce((acc, key) => {
    acc[key] = code[key];
    return acc;
  }, {});
export default sortedCodes;
